<template>
  <div class="targets">
    <target-card
      v-for="target in targets"
      :target="target"
      class="float-left"
      :key="target.id"
      v-on:target-deleted="updateTargets"
    />
    <target-card v-on:target-saved="updateTargets" />
  </div>
</template>

<script>
import TargetCard from '@/components/TargetCard.vue'

import { TARGETS_QUERY } from '@/constants/graphql'

export default {
  name: 'targets',
  data () {
    return {
      loading: 0,
      error: null
    }
  },
  methods: {
    updateTargets () {
      this.$apollo.queries.targets.refetch()
    }
  },
  components: {
    TargetCard
  },
  apollo: {
    targets: {
      query: TARGETS_QUERY,
      error () {
        this.error = true
      }
    }
  },
  mounted () {
    this.updateTargets()
  }
}
</script>
